import { chooseLanguage, getPreferredLanguage, t } from '../i18n';
import { APP_TOAST_EVENT, dispatchAppEvent } from '../services/authEvents';

/**
 * R9 EN / اردو switch (sits next to the dark-mode toggle). Shows the language
 * you would switch TO, in that language, so it is readable either way.
 */
export default function LanguageToggle({ className = '' }) {
  const urdu = getPreferredLanguage() === 'ur';
  const next = urdu ? 'en' : 'ur';
  const label = urdu ? t('language.toEnglish') : t('language.toUrdu');
  return (
    <button
      type="button"
      onClick={() => chooseLanguage(next).then((active) => {
        if (active !== next) dispatchAppEvent(APP_TOAST_EVENT, { severity: 'error', message: t('language.loadFailed') });
      })}
      aria-label={label}
      title={label}
      lang={next}
      className={`inline-flex h-9 min-w-[2.25rem] shrink-0 items-center justify-center rounded-full border border-slate-200 px-2 text-xs font-semibold text-slate-700 transition hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary ${className}`}
      data-testid="language-toggle"
    >
      {urdu ? 'EN' : <span className="font-urdu text-sm leading-none">اردو</span>}
    </button>
  );
}
